import React, { useState, useEffect } from 'react';
import { TicketList, TicketCreateModal, TicketView } from './components';
import { getTickets } from '../../store/action/ticket';
import { formatAPIData} from './helpers/formatters';

const Ticket = (props) => {
    const [ newTicketModal , setNewTicketModal ] = useState(false);
    const [ filters, setFilters ] = useState({});
    const [ viewHeight, setViewHeight ] = useState(0);
    const [ tickets, setTickets ] = useState([]);
    const [ ticketId, setTicketId ] = useState("");

    useEffect(() => {
        getTicketData(filters);
        const intervalId = setInterval(() => {
            getTicketData(filters);
        }, 30000);
        return () => clearInterval(intervalId);
    },[]);


    const getTicketData = async (f) => {
        setFilters(f);
        const response = await getTickets(f);
        if (response.success) {
            setTickets(formatAPIData(response.tickets));
            return
        } else {
            alert(response.error);
            return
        }
    }

    return (
        <div className="mb-4">
            
            <TicketCreateModal 
                show={newTicketModal} 
                onHide={() => setNewTicketModal(false)}
            />

        
            <div className="bg-white rounded shadow mb-4">
                <div className="d-flex justify-content-between p-4">
                    <h5>Support Tiket</h5>
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={() => setNewTicketModal(true)}
                    >
                        Tambah Tiket
                    </button>
                </div>


                <div className='border-top'>
                    <div className='row'>
                        <div className='col-5 pr-0'>
                            <TicketList 
                                height={viewHeight}
                                tickets={tickets}
                                onSelect={id => setTicketId(id)}
                                onChangeDate={getTicketData}
                            />
                        </div>
                        <div className='col-7 pl-0 border-left '>
                            <TicketView 
                                onRefresh={getTicketData}
                                onHeightChanges={setViewHeight}
                                ticketId={ticketId}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Ticket